<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListBanners";

export default {
  data() {
    return {
      subjectPermission: "Banners",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
